(function(){
  function init(){
    document.querySelectorAll('.za-model-finder:not(.za-tent-finder),.za-series-compare').forEach(function(block){
      block.querySelectorAll('a.za-series-compare__button').forEach(function(a){a.classList.replace('za-series-compare__button','za-comparison-link')});
      var rows=Array.from(block.querySelectorAll('.za-model-row,tbody tr'));
      rows.forEach(function(row){
        if(row.dataset.comparisonSelect)return;
        row.dataset.comparisonSelect='true';row.tabIndex=0;
        var title=row.querySelector('strong,th');
        row.setAttribute('aria-label','Select '+(title?title.textContent.trim():'option'));
        function select(){rows.forEach(function(r){var yes=r===row;r.classList.toggle('is-selected',yes);if(yes)r.setAttribute('aria-current','true');else r.removeAttribute('aria-current')})}
        row.addEventListener('click',function(e){if(e.target.closest('a,button,input,select,textarea'))return;select()});
        row.addEventListener('keydown',function(e){if(e.target!==row)return;if(e.key==='Enter'||e.key===' '){e.preventDefault();select()}});
      });
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();
